import { render, staticRenderFns } from "./wineCooler.vue?vue&type=template&id=51086bc1&"
import script from "./wineCooler.vue?vue&type=script&lang=js&"
export * from "./wineCooler.vue?vue&type=script&lang=js&"
import style0 from "./wineCooler.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports